(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestseller-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:section:load', initBestseller);
document.addEventListener('DOMContentLoaded', initBestseller);

function initBestseller() {
  const sections = document.querySelectorAll('.bestseller-section');

  sections.forEach(section => {
    const tabs = section.querySelectorAll('.bestseller-tab');
    const sliders = section.querySelectorAll('.bestseller-slider-container');
    const prevBtn = section.querySelector('.bestseller-arrow.prev');
    const nextBtn = section.querySelector('.bestseller-arrow.next');

    let currentTab = section.querySelector('.bestseller-tab.active');
    let currentSlider = section.querySelector(`#${currentTab.dataset.tab}`);
    let position = 0;

    const desktopCols = parseInt(section.dataset.desktopColumns);
    const mobileCols = parseInt(section.dataset.mobileColumns);
    const cardGap = parseInt(section.dataset.cardGap) || 24;

    function visibleCardsCount() {
      return window.innerWidth <= 768 ? mobileCols : desktopCols;
    }

    function updateCardWidths() {
      const visible = visibleCardsCount();
      const sliderContainer = currentSlider;
      const slider = currentSlider.querySelector('.bestseller-slider');
      const cards = slider.querySelectorAll('.bestseller-card');

      if (cards.length === 0) return;

      const containerWidth = sliderContainer.offsetWidth;
      const totalGap = (visible - 1) * cardGap;
      const cardWidth = (containerWidth - totalGap) / visible;

      cards.forEach(card => {
        card.style.width = `${cardWidth}px`;
        card.style.flexShrink = '0';
      });

      const totalWidth = (cardWidth * cards.length) + (cardGap * (cards.length - 1));
      slider.style.width = `${totalWidth}px`;

      updateSliderPosition();
    }

    function getMaxPosition() {
      const slider = currentSlider.querySelector('.bestseller-slider');
      const cards = slider.querySelectorAll('.bestseller-card');
      const visible = visibleCardsCount();
      return Math.max(0, cards.length - visible);
    }

    function updateSliderPosition() {
      const slider = currentSlider.querySelector('.bestseller-slider');
      const maxPosition = getMaxPosition();

      position = Math.max(0, Math.min(position, maxPosition));

      const visible = visibleCardsCount();
      const containerWidth = currentSlider.offsetWidth;
      const totalGap = (visible - 1) * cardGap;
      const cardWidth = (containerWidth - totalGap) / visible;

      const translateX = position * (cardWidth + cardGap);
      slider.style.transform = `translateX(-${translateX}px)`;

      updateArrowStates();
    }

    function updateArrowStates() {
      const maxPosition = getMaxPosition();
      prevBtn.classList.toggle('disabled', position === 0);
      nextBtn.classList.toggle('disabled', position >= maxPosition);
    }

    function nextSlide() {
      const maxPosition = getMaxPosition();
      if (position < maxPosition) {
        position++;
        updateSliderPosition();
      }
    }

    function prevSlide() {
      if (position > 0) {
        position--;
        updateSliderPosition();
      }
    }

    nextBtn.addEventListener('click', nextSlide);
    prevBtn.addEventListener('click', prevSlide);

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('active'));
        sliders.forEach(s => s.classList.add('hidden'));

        tab.classList.add('active');
        currentTab = tab;
        currentSlider = section.querySelector(`#${tab.dataset.tab}`);
        currentSlider.classList.remove('hidden');

        position = 0;
        updateCardWidths();
        updateSliderPosition();
      });
    });

    function initializeSlider() {
      updateCardWidths();
      updateSliderPosition();
    }

    let resizeObserver;
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(() => {
        updateCardWidths();
      });
      resizeObserver.observe(section);
    } else {
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          updateCardWidths();
        }, 250);
      });
    }

    setTimeout(() => {
      initializeSlider();
    }, 100);

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', initializeSlider);
      document.addEventListener('shopify:section:deselect', initializeSlider);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-custom-mega-menu"]) return;
  try {
    
  class HeaderMenu extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      
      this.details.addEventListener('toggle', this.onToggle.bind(this));
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      this.querySelector('button[type="button"]')?.addEventListener('click', this.close.bind(this));
      
      this.details.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.close();
      });
    }

    onToggle() {
      if (!this.details.open) {
        this.details.classList.remove('menu-opening');
      }
    }

    onSummaryClick(event) {
      event.preventDefault();
      if (this.details.open) {
        this.close();
      } else {
        this.open(event);
      }
    }

    open(event) {
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      event.target.closest('details').addEventListener('focusout', this.onBodyClickEvent);
      
      // Close other open menus
      const headerMenus = document.querySelectorAll('header-menu');
      headerMenus.forEach(menu => {
        if (menu !== this && menu.querySelector('details[open]')) {
          menu.close();
        }
      });
      
      this.details.open = true;
      this.details.classList.add('menu-opening');
    }

    close() {
      this.details.removeEventListener('focusout', this.onBodyClickEvent);
      this.details.open = false;
      this.details.classList.remove('menu-opening');
    }

    onBodyClick(event) {
      if (!this.contains(event.target) || event.target.classList.contains('mega-menu__link')) {
        this.close();
      }
    }
  }

  customElements.define('header-menu', HeaderMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
